import React from "react";
import "./Scrolltopbutton.css";
import {FaArrowUp} from "react-icons/fa"

function Scrolltopbutton(){
    return(
        <div className="scroll-button">
            <a href="#home">
            <button href="#home" className="round-button">
                <FaArrowUp />
            </button>
            </a>
        </div>
    );
}

export default Scrolltopbutton;